<template>
  <!---通过搜索列表页面（组件）-->
  <div style="height: 100%;">
    <search-header :col="col" :buttonCol="buttonCol">
      <search-list>
        <template v-if="itemNames.length<col">
          <slot v-for="(item,index) in itemNames" :name="item" :index="index">{{ item }}</slot>
        </template>
        <template v-else>
          <slot v-for="(item,index) in getShowList(itemNames)" :name="item" :index="index">{{ item }}</slot>
          <template v-if="advancedState">
            <slot v-for="(item,index) in getAdvancedList(itemNames)" :name="item" :index="index"></slot>
          </template>
        </template>
        <a-form-item v-if="enableSearch" :style="{'padding-left': leftSpace +'px'}">
          <search-combination-button
            :show-advanced="showAdvanced && itemNames.length>col-1"
            :unfoldState="advancedState"
            :menuList="menuList"
            :exportType="exportType"
            :size="buttonSize"
            @search="searchEvent"
            :showResetButton="showResetButton"
            @reset="resetEvent"
            @export="exportEvent"
            @change="advancedChange"
          >
            <slot v-for="(item,index) in buttonItems" :name="item" :index="index"></slot>
          </search-combination-button>
        </a-form-item>
        <template v-if="rightButton">
          <slot :name="rightButton"></slot>
        </template>
      </search-list>
    </search-header>
    <slot :name="operation"></slot>
    <custom-page-table
      ref="table"
      :size="tableSize"
      :rowKey="rowKey"
      :columns="columns"
      :load-data="loadData"
      :queryParams="queryParams"
      :request-promise="requestPromise"
      :rowSelection="rowSelection"
      :request-type="requestType"
      :query-path="queryPath"
      :params-path="paramsPath"
      :base-key="baseKey"
      :page-size="pageSize"
      :showResetButton="showResetButton"
      :extraPaginationName="extraPaginationName"
      :customPagination="customPagination"
      :expandedRowRender="expandedRowRender"
    >
      <!-- 动态修改表头内容时columns对应列里面不能加title属性，否则不生效 -->
      <!-- slots: { title: 'ticketId' }-->
      <template v-for="(item, i) in headerRenders" :slot="item">
        <slot :name="item"></slot>
      </template>
      <template v-for="(item, i) in customRenders" :slot="item" slot-scope="rowItem">
        <slot :name="item" :text="rowItem.text" :record="rowItem.record" :index="rowItem.index"></slot>
      </template>
      <template :slot="extraPaginationName">
        <slot :name="extraPaginationName"></slot>
      </template>
      <template :slot="expandedRowRender" slot-scope="rowItem">
        <slot :name="expandedRowRender" :record="rowItem.record" :index="rowItem.index"></slot>
      </template>
    </custom-page-table>
  </div>
</template>
<script>
import SearchHeader from '../SearchHeader'
import SearchCombinationButton from '../SearchCombinationButton'
import CustomPageTable from '../CustomPageTable/CustomPageTable'

const SearchList = SearchHeader.SearchList
export default {
  name: 'SearchPageView',
  components: {
    SearchHeader,
    SearchList,
    SearchCombinationButton,
    CustomPageTable
  },
  props: {
    leftSpace: {
      type: Number,
      default: 0
    },
    itemNames: {
      type: Array,
      default: function() {
        return []
      }
    },
    buttonItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    col: {
      type: Number,
      default: 3
    },
    pageSize: {
      type: Number,
      default: 10
    },
    buttonCol: {
      type: Number,
      default: 0
    },
    rowKey: {
      type: String,
      default: ''
    },
    rightButton: {
      type: String,
      default: ''
    },
    requestType: {
      type: String,
      default: 'post'
    },
    //查询式请求路径
    queryPath: {
      type: String,
      default: ''
    },
    //参数式请求路径
    paramsPath: {
      type: String,
      default: ''
    },
    //请求基础模块
    baseKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    tableSize: {
      type: String,
      default: 'default'
    },
    buttonSize: {
      type: String,
      default: 'default'
    },
    showAdvanced: {
      type: Boolean,
      default: false
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    rowSelection: {
      type: Object,
      default: null
    },
    operation: {
      type: String,
      default: 'operation'
    },
    //导出类型  1、是菜单类型  2是按钮类型
    exportType: {
      type: Number,
      default: 0
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    //（导出）菜单列表
    menuList: {
      type: Array,
      default: () => ['CSV', 'Excel']
    },
    //菜单数据关键字（当列表数据不是字符串或者数字时，才传）
    itemKey: {
      type: String,
      default: ''
    },
    //查询参数
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    //请求的
    requestPromise: {
      type: Function,
      default: undefined
    },

    loadData: {
      type: Function,
      default: undefined
    },
    // 自定义分页显示
    customPagination: {
      type: Boolean,
      default: true
    },
    //分页附加信息
    extraPaginationName: {
      type: String,
      default: 'extraPaginationName'
    },
    beforeSearch: {
      type: Function,
      default: undefined
    },
    expandedRowRender: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      customRenders: [],
      headerRenders: [],
      advancedState: true
    }
  },
  watch: {
    'columns': function(columnsList) {
      this.customRenders = this.getCustomRendersList(columnsList)
      this.headerRenders = this.getHeaderRendersList(columnsList)
    }
  },
  mounted() {
    this.getLogUtils().logWithTag('showResetButton', this.showResetButton)
    this.customRenders = this.getCustomRendersList(this.columns)
    this.headerRenders = this.getHeaderRendersList(this.columns)
  },
  methods: {
    searchEvent(res) {
      if (this.beforeSearch) {
        this.beforeSearch()
      }
      this.$refs.table.refresh(true)
    },
    getCustomRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.scopedSlots && item.scopedSlots.customRender) {
            customList.push(item.scopedSlots.customRender)
          }
        })
      }
      return customList
    },
    getHeaderRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.slots && item.slots.title) {
            customList.push(item.slots.title)
          }
        })
      }
      return customList
    },
    refresh(bool = false) {
      this.$refs.table.refresh(bool)
    },
    advancedChange(state) {
      this.advancedState = state
    },
    resetEvent() {
      this.$emit('reset')
    },
    exportEvent() {
      this.$emit('export')
    },
    getShowList(list) {
      const count = this.col - 1
      if (list && list.length > count) {
        return list.slice(0, count)
      }
      return []
    },
    getAdvancedList(list) {
      const count = this.col - 1
      if (list && list.length > count) {
        return list.slice(count, list.length)
      }
      return []
    },
    updateSelect(selectedRowKeys, selectedRows) {
      this.$refs.table.updateSelect(selectedRowKeys, selectedRows)
    }
  }
}
</script>
<style scoped>
</style>